<script lang="ts">
  import Select from '@leaflink/stash/Select.vue';

  import LicenseTypeChip from '@/components/LicenseTypeChip/LicenseTypeChip.vue';

  const OPTION_TYPES = {
    COMPANY: 'company',
    LICENSE: 'license',
  };

  export default {
    name: 'LicensePicker',

    components: {
      LicenseTypeChip,
      Select,
    },

    props: {
      label: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        required: true,
      },
      modelValue: {
        type: Object,
        default: () => ({}),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hideCheck: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      optionType: {
        type: String,
        default: OPTION_TYPES.COMPANY,
        validator: (value: string) => [OPTION_TYPES.COMPANY, OPTION_TYPES.LICENSE].includes(value),
      },
    },

    data() {
      return { OPTION_TYPES };
    },

    computed: {
      /**
       * Used to determine conditional UI
       * If option types is 'company', the option UI will show company name, then license type chip
       * If option type is 'license', the option UI will show license type chip, then license name
       */
      isCompanyOptionType() {
        return this.optionType === this.OPTION_TYPES.COMPANY;
      },
    },

    emits: ['update:model-value'],
  };
</script>

<template>
  <Select
    single
    hide-search
    prevent-empty
    :disabled="disabled"
    :hide-check="hideCheck"
    :label="label"
    :loading="isLoading"
    :options="options"
    :model-value="modelValue"
    @update:model-value="(v) => $emit('update:model-value', v)"
  >
    <template #selected="{ option }">
      <div class="flex align-middle w-full" :class="{ 'align-justify': isCompanyOptionType }">
        <span
          :data-test="option.name"
          :class="[
            'text-truncate',
            {
              'll-ml-1': !isCompanyOptionType,
              [$style['license-option-chip']]: !isCompanyOptionType,
            },
          ]"
        >
          {{ option.name }}
        </span>

        <LicenseTypeChip v-if="option.licenses.length" :license="option.licenses[0]" class="tw-mr-6" />
      </div>
    </template>

    <template #option="{ option }">
      <div :class="['flex align-middle w-full', { 'align-justify': isCompanyOptionType }]">
        <span
          :data-test="option.name"
          :class="{
            'll-ml-1': !isCompanyOptionType,
            [$style['license-option-chip']]: !isCompanyOptionType,
          }"
        >
          {{ option.name }}
        </span>

        <LicenseTypeChip v-if="option.licenses.length" :license="option.licenses[0]" />
      </div>
    </template>
  </Select>
</template>

<style lang="scss" module>
  .license-option-chip {
    order: 2;
  }

  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
